import actions from '../actions';
import { APP_INIT, ACCOUNT_INTRO_COMPLETE } from '../actionTypes';

const handleIntro = (storage, beforeState, afterState, action, store) => {
  if (action.type === APP_INIT) {
    const accepted = storage.get('intro') || false;
    if (accepted) {
      store.dispatch(actions.accountIntroComplete());
    }
  }

  if (action.type === ACCOUNT_INTRO_COMPLETE) {
    storage.set('intro', true);
  }
};

export default handleIntro;



// WEBPACK FOOTER //
// ./src/middleware/introPersistence.js